<template>
  <div class="pa-6">
    <div class="d-flex justify-space-between align-center mb-6">
      <div class="component-title">Quản lý Popup hiển thị trên APP</div>
      <v-btn @click="() => $refs['create-dialog'].openDialog({isEdit: false})" color="admin" class="white--text"
        >Thêm mới</v-btn
      >
    </div>
    <v-card class="pa-6 elevation-1 mb-6">
      <DocumentFilter @onFilterChanged="onFilterChanged" />
    </v-card>
    <v-card class="elevation-1">
      <DocumentTable ref="documentTable" @onDetail="val => $refs['create-dialog'].openDialog(val)" />
    </v-card>
    <CreateDialog ref="create-dialog" @onRefresh="onRefresh" />
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import CreateDialog from './CreateDialog.vue'
import DocumentFilter from './ListFilter.vue'
import DocumentTable from './ListTable.vue'

export default {
  components: {DocumentFilter, DocumentTable, CreateDialog},
  computed: {
    ...mapGetters('auth', ['user']),
  },
  async mounted() {
    await this.countItems()
  },
  methods: {
    ...mapActions({fetchItems: 'adsPopup/fetchItems', countItems: 'adsPopup/countItems'}),
    async onFilterChanged(data) {
      this.$loading.active = true
      const params = {...data}
      await this.fetchItems({...params, _start: 0, _limit: 10, _sort: 'createdAt:DESC'})
      await this.countItems(params)
      this.$loading.active = false
    },
    async onRefresh() {
      await this.fetchItems({_start: 0, _limit: 10, _sort: 'createdAt:DESC'})
      await this.countItems()
    },
  },
  async beforeDestroy() {
    await this.resetState()
  },
}
</script>
<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
